const baseStyleButton = {
    _expanded: { bg: "transparent", boxShadow: "none" },
    _hover: { bg: "transparent" },
    py: { base: 4, lg: 6 },
};
const baseStylePanel = {
    pb: { base: 4, lg: 6 },
};
const baseStyleIcon = {
    color: "primary.500",
    boxSize: 6,
    ml: 2,
};
const primary = {
    container: {
        bg: "transparent",
        borderColor: "greyscale.400",
        _first: { borderTop: "none" },
    },
    button: { px: 0 },
    panel: { px: 0, pt: { base: 0, lg: 1 } },
};
const secondaryButtonPanelStyles = {
    px: { base: 4, lg: 6 },
    bg: "greyscale.100",
    borderRadius: "lg",
    mb: 2,
};
const secondary = {
    container: { border: "none" },
    button: {
        ...secondaryButtonPanelStyles,
        _expanded: { mb: 0, borderBottomRadius: "none", bg: "greyscale.100" },
        _hover: { bg: { md: "greyscale.100" } },
    },
    panel: {
        ...secondaryButtonPanelStyles,
        borderTopRadius: "none",
        pt: 0,
    },
};
const variants = {
    primary,
    secondary,
};
const baseStyle = {
    panel: baseStylePanel,
    button: baseStyleButton,
    icon: baseStyleIcon,
};
const defaultProps = {
    variant: "primary",
};
const Accordion = {
    defaultProps,
    baseStyle,
    variants,
};
export default Accordion;
